import { Linkedin, Instagram, Twitter } from "lucide-react";
import { Wordmark } from "./Navbar";
import { scrollToId } from "./Reveal";
import MobileCTA from "./MobileCTA";

const NAV = [
  { label: "Platform", href: "/platform" },
  { label: "Features", href: "/platform" },
  { label: "How It Works", href: "/how-it-works" },
  { label: "Solutions", href: "#who" },
  { label: "Pricing", href: "#pricing" },
  { label: "Contact", href: "#demo" },
  { label: "Privacy", href: "#" },
  { label: "Terms", href: "#" },
];

export default function Footer() {
  return (
    <footer id="contact" className="bg-ink text-paper" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 lg:grid-cols-12 lg:py-20">
        <div className="lg:col-span-5">
          <Wordmark light />
          <p className="mt-4 font-serif text-xl text-paper/70">Powering Destination Experts</p>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-paper/50">
            Everything your DMC needs to take a destination business online —
            website, inventory, packages, inquiries and quotations in one platform.
          </p>
          <div className="mt-8 space-y-1.5 font-mono text-xs text-paper/40" data-testid="footer-contact-placeholders">
            <p>
              Email ·{" "}
              <a href="mailto:connect@travel-tek.com" data-testid="footer-email-link" className="text-paper/60 underline decoration-terra/60 underline-offset-4 hover:text-paper">
                connect@travel-tek.com
              </a>
            </p>
            <p>Address · New Delhi, India</p>
            <p className="pt-2 text-paper/60">
              <a href="https://travel-tek.com" className="underline decoration-terra/60 underline-offset-4 hover:text-paper" data-testid="footer-website-link">
                travel-tek.com
              </a>
            </p>
            <p className="pt-3 text-paper/50">
              Country pricing brochures ·{" "}
              <a href="/brochures/india" data-testid="footer-brochure-india" className="underline decoration-terra/60 underline-offset-4 hover:text-paper">India</a>
              {" · "}
              <a href="/brochures/uae" data-testid="footer-brochure-uae" className="underline decoration-terra/60 underline-offset-4 hover:text-paper">UAE</a>
              {" · "}
              <a href="/brochures/southeast-asia" data-testid="footer-brochure-southeast-asia" className="underline decoration-terra/60 underline-offset-4 hover:text-paper">Southeast Asia</a>
            </p>
          </div>
          <MobileCTA />
        </div>
        <div className="lg:col-span-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-paper/40">Navigate</p>
          <nav className="mt-5 grid grid-cols-2 gap-2">
            {NAV.map((n) => (
              <a
                key={n.label}
                href={n.href}
                onClick={n.href.startsWith("#") && n.href.length > 1 ? scrollToId(n.href) : undefined}
                data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="py-1.5 text-sm text-paper/70 transition-colors duration-300 hover:text-terra"
              >
                {n.label}
              </a>
            ))}
          </nav>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-paper/40">Social</p>
          <div className="mt-5 flex gap-3">
            {[
              { icon: Linkedin, label: "LinkedIn" },
              { icon: Instagram, label: "Instagram" },
              { icon: Twitter, label: "Twitter" },
            ].map((s) => (
              <span
                key={s.label}
                title={`${s.label} — link coming soon`}
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="flex h-10 w-10 cursor-not-allowed items-center justify-center rounded-full border border-white/15 text-paper/50"
              >
                <s.icon className="h-4 w-4" />
              </span>
            ))}
          </div>
          <p className="mt-4 font-mono text-[10px] text-paper/30">Profiles to be added</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-wrap items-center justify-between gap-4 py-6">
          <p className="text-xs text-paper/40">© 2026 Travel-Tek. All rights reserved.</p>
          <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.18em] text-paper/40" data-testid="footer-status">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400" />
            All systems operational
          </p>
        </div>
      </div>
    </footer>
  );
}
